import React, { useContext, useEffect, useState } from "react";

import "./stylesMarketingAffiliates.css";
import Layout from "../../CommonComponents/Layout/Layout";

import AppContext from "../../../context/AppContext";
import { SIDER_TABS } from "../../../utils/Constants";
import CustomAutoComplete from "../../CommonComponents/CustomAutoComplete/CustomAutoComplete";
import ExpandableRowTable from "../../CommonComponents/ExpandableRowTable/ExpandableRowTable";
import CustomDatePicker from "../../CommonComponents/CustomDatePicker/CustomDatePicker";

import dayjs from "dayjs";


function MarketingAffiliates() {
  const { setActiveSidebarTab } = useContext(AppContext);

  const [activeTab, setActiveTab] = useState("Affiliate List");

  const tabs = [
    "Affiliate List",
    "Affiliate KPIs",
    "Financials",
    "Individualized Stats",
  ];

  useEffect(() => {
    console.log("Setting active sidetab Affiliates");
    setActiveSidebarTab(SIDER_TABS.MARKETING, "Affiliates");
  }, [setActiveSidebarTab]);

  const todayRange = [dayjs(), dayjs()];

  return (
    <Layout>
      <div className="marketing-affiliates-container">
        <div className="marketing-affiliates">
          <>
            <div className="head-controls">
              <div className="header-text-container">
                <p className="header-text">Affiliates</p>
              </div>
            </div>
            <div className="dashboard-tabs">
              {tabs.map((tab) => (
                <button
                  className={activeTab === tab ? "active" : null}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="marketing-affiliates-content">
              <div className="marketing-affiliates-content-header">
                <div className="marketing-affiliates-autocomplete-container">
                  <CustomAutoComplete
                    placeholder="Search name, code..."
                    allOptions={[
                      {
                        label: "OddsChecker",
                        value: "OddsChecker",
                      },
                      {
                        label: "Action Network",
                        value: "Action Network",
                      },
                      { label: "Barstool Sports", value: "Barstool Sports" },
                      { label: "Ralph Edwards", value: "Ralph Edwards" },
                      {
                        label: "BetQL",
                        value: "BetQL",
                      },
                      { label: "Rotoworld", value: "Rotoworld" },
                    ]}
                  />
                  <CustomDatePicker
                    getData={() => {}}
                    dates={todayRange}
                    setDates={() => {}}
                  />
                </div>
              </div>
              <ExpandableRowTable />
            </div>
          </>
        </div>
      </div>
    </Layout>
  );
}

export default MarketingAffiliates;
